import { useState } from 'react';

export default function SearchBar({ onSearch }) {
  const [input, setInput] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      onSearch(input);
    }
  };

  return (
    <div className="max-w-2xl mx-auto mb-12">
      <form onSubmit={handleSubmit}>
        <div className="relative">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Search for a product..."
            className="w-full px-6 py-4 rounded-lg border-2 border-slate-300 focus:border-sky-600 focus:outline-none text-lg placeholder-slate-400 shadow-sm focus:shadow-lg transition-all duration-200"
          />
          <button
            type="submit"
            className="absolute right-2 top-1/2 -translate-y-1/2 px-6 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors font-medium"
          >
            Search
          </button>
        </div>
      </form>
      <p className="text-center text-slate-500 text-sm mt-4">
        Searching across Amazon, Google, Trustpilot, Reddit, and more...
      </p>
    </div>
  );
}
